import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subscription, interval } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  httpHeaders = new HttpHeaders({'Content-type': 'application/json'});
  companiesUrl: string;
  workersUrl: string;

  subscription: Subscription;
  

  constructor(
    private http: HttpClient,
    private msg: NzMessageService,
    private router: Router) {
    this.companiesUrl = environment.getBackendUrl('companies');
    this.workersUrl = environment.getBackendUrl('workers');
  }

  getLastUpdates(): Observable<any> {
    return this.http.get(this.companiesUrl + '/last_updates/',
      {
       headers: this.httpHeaders
      }
    );
  }

  //Actualizacion de datos de compra y venta
  updateSalesPurchases(service: string): Observable<any> {
    const body = {
            service: service
          }
    return this.http.get(this.companiesUrl + '/update_data/',
      {
       headers: this.httpHeaders,
       params: body,
      }
    );
  }

  //chequeo de una tarea terminada retorna 200 o 404
  checkTask(taskId): Observable<any> {
    let body = {task_id: taskId}
    return this.http.post(this.workersUrl + '/single/', body,
    { headers: this.httpHeaders,observe: 'response'  }).pipe(
      map(response => response)
    );
  }

  checkGroup(groupId): Observable<any> {
    let body = {group_id: groupId};
    return this.http.post(this.workersUrl + '/group/', body,
    { headers: this.httpHeaders,observe: 'response'  }).pipe(
      map(response => response)
    );
  }

  callCheckTask(url: string, taskType: string, taskId: string, taskIdType: boolean){
    const source = interval(5000);
    this.subscription = source.subscribe(val =>{
      //console.log('check connections');
      if(taskIdType){
        this.checkTask(taskId).subscribe(
          resp => {
            if (resp['status'] === 200){
              if(resp['body']['status'] === 'SUCCESS'){
                if (this.router.url === url){
                  //Reload componen
                  //Actualizar componente si es que se está navegando en el mismo
                  this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                  this.router.onSameUrlNavigation = 'reload';
                  this.router.navigate([url]);
                }
                
                this.subscription.unsubscribe();
                //this.msg.success('Se ha actualizado '+taskType);
              }              
            }
          },
          err => {
            //console.log(err['status']);
          });
      }else{
        this.checkGroup(taskId).subscribe(
          resp => {
            if (resp['status'] === 200){
              if(resp['body']['status'] === 'SUCCESS'){
                if (this.router.url === url){
                  //Actualizar componente si es que se está navegando en el mismo
                  this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                  this.router.onSameUrlNavigation = 'reload';
                  this.router.navigate([url]);
                }
                
                this.subscription.unsubscribe();
                this.msg.success('Se ha actualizado '+taskType);
              }
            }
          },
          err => {
            //console.log(err['status']);
          });
      }

    }); 
  }

  titleCase(str) {
    if (str){
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        }
        // Directly return the joined string
        return splitStr.join(' '); 
    }
 }

}
